/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { InjectionToken } from '@angular/core';
/**
 *  Injection token unique to the flex-layout library.
 *  Use this token when build a custom provider (see below).
 */
export var BREAKPOINTS = new InjectionToken('Token (@angular/flex-layout) Breakpoints');
//# sourceMappingURL=break-points-token.js.map


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/@angular/flex-layout/media-query/breakpoints/break-points-token.js
// module id = ../../../flex-layout/media-query/breakpoints/break-points-token.js
// module chunks = 4